import { AI_ANALYST_ADMIN_SEGMENT, AI_ANALYST_SEGMENT } from './ai-analyst-route.util';

const DASHBOARD_ROUTE = '/dashboard';
const PREFIX_ROUTES = ['my-dashboard', 'samples/', 'sample-details', 'sample-result/', 'sample-history', 'segs/', 'risk-assessments', 'risk-assessment/'].map(route => `${DASHBOARD_ROUTE}/${route}`);
const SECTION_ROUTES = [AI_ANALYST_SEGMENT, AI_ANALYST_ADMIN_SEGMENT].map(segment => `${DASHBOARD_ROUTE}/${segment}`);

export function isDateFilterHiddenRoute(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return path === DASHBOARD_ROUTE
    || PREFIX_ROUTES.some(route => path.startsWith(route))
    || SECTION_ROUTES.some(route => path === route || path.startsWith(`${route}/`));
}
